/**
 * OrangeHRM WhatsApp Plugin pages
 */
import WhatsAppIntegration from './pages/WhatsAppIntegration.vue';
import WhatsAppConfig from './pages/WhatsAppConfig.vue';
import DailyDigestQuotes from './pages/DailyDigestQuotes.vue';

export default {
  'whatsapp-integration': WhatsAppIntegration,
  'whatsapp-config': WhatsAppConfig,
  'daily-digest-quotes': DailyDigestQuotes,
};
